module.exports = [{"name":"大型汽车-黄牌","code":"01"},{"name":"小型汽车-蓝牌","code":"02"},{"name":"外籍汽车-黑牌","code":"06"},{"name":"警用汽车-白牌","code":"23"},{"name":"新能源汽车-绿牌","code":"09"},{"name":"新能源汽车-黄绿","code":"10"},{"name":"其他","code":"99"}]


//////////////////
// WEBPACK FOOTER
// ./static/json/dictionary/plateClassType.json
// module id = Hd1o
// module chunks = 11